import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

// Send anyone who is not signed in back to the login page
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  return authService.isUserSignedin() ? true : inject(Router).createUrlTree(['/login']);
};
